import { ReactNode, useCallback, useMemo } from "react";
import clsx from "clsx";
import {
  TabsContext,
  TabsValue,
  TabsStyleConfig,
  mergeTabsStyles,
} from "./TabsContext";

export type TabsRootProps<T extends TabsValue> = {
  value: T;
  onValueChange: (next: T) => void;
  className?: string;
  styles?: TabsStyleConfig;
  children: ReactNode;
};

export const TabsRoot = <T extends TabsValue>({
  value,
  onValueChange,
  className,
  styles,
  children,
}: TabsRootProps<T>) => {
  const setValue = useCallback(
    (next: TabsValue) => {
      onValueChange(next as T);
    },
    [onValueChange],
  );

  const mergedStyles = useMemo(() => mergeTabsStyles(styles), [styles]);

  const ctx = useMemo(
    () => ({ value: value as TabsValue, setValue, styles: mergedStyles }),
    [value, setValue, mergedStyles],
  );

  return (
    <TabsContext.Provider value={ctx}>
      <div className={clsx("w-full", className)}>{children}</div>
    </TabsContext.Provider>
  );
};
